import cn from 'classnames';
import React, {FunctionComponent, ReactNode} from 'react';

import './Stepper.scss';

interface IStepperProps {
    activeStep: number, // Starts at 1
    steps: string[],
}


// Shows a series of filled circles to indicate progress. Doesn't support labels for now.
export const Stepper: FunctionComponent<IStepperProps> = function(props) {
    const { activeStep, steps } = props;

    return (
        <div className="stepper">
            {steps.map((label, i) => {
                const stepNum = i + 1;

                // Each step renders as:
                // --------(1)--------
                //        Label
                // The left/right lines are invisible for the first/last steps, respectively.

                return (
                    <div className="stepper_step" key={i}>
                        <div className="stepper_dotAndLines">
                            <div className={cn({
                                stepper_left: true,
                                active: activeStep >= stepNum,
                                visible: i > 0,
                            })}></div>
                            <div className={cn({
                                stepper_dot: true,
                                active: activeStep >= stepNum,
                            })}>
                                {stepNum}
                            </div>
                            <div className={cn({
                                stepper_right: true,
                                active: activeStep > stepNum,
                                visible: stepNum < steps.length,
                            })}></div>
                        </div>
                        <div className={cn({
                            stepper_label: true,
                            active: activeStep === stepNum,
                        })} title={label}>
                            {label}
                        </div>
                    </div>
                )
            })}
        </div>
    );
};